import React from "react";
import "./storm.scss";
import { Link } from "react-router-dom";


const Storm = () => {
  return (
    <>
      <div className="stormouter_layer">
        <section ion className="main-storm">
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source
              src="https://res.cloudinary.com/drt6vurtt/video/upload/v1736357338/rain-prediction/joinvideo_o0v9oi.mov"
              type="video/mp4"
            />
          </video>
          <div className="custom-containerr">
            <div className="inner-storm">
              <div className="leftsidestormtop">
                <h3>RAIN</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="34"
                  viewBox="0 0 35 34"
                  fill="none"
                >
                  <path
                    d="M17.3401 0C18.1574 12.5011 32.2335 10.8766 32.2335 16.4536C32.2335 21.0003 25.5471 23.4372 17.2956 23.4372C9.04401 23.4372 2.35758 21.0003 2.35758 16.4536C2.35263 10.8766 16.4288 12.5011 17.251 0C7.71663 0.0247645 0 7.4046 0 16.513C0 25.6214 7.74139 33.026 17.2956 33.026C26.8497 33.026 34.5911 25.6313 34.5911 16.513C34.5911 7.39469 26.8695 0.0247645 17.3401 0Z"
                    fill="black"
                  />
                </svg>
                <h3>2026</h3>
              </div>
              <div className="storm-outter">
                <div className="leftsidestorm">
                  <div>
                    <h2>Weather the Storm</h2>
                    <p>
                      Prediction systems are expanding into more and more
                      technological landscapes. Build independently or join our
                      Grants Program to prepare your project for whatever comes
                      next.
                    </p>
                    <div className="bothbuttonns">
                      <Link to="/builders">
                        <button className="apply">Builder Grants</button>

                      </Link>
                      {/* <Link to="/builders">
                        <button className="explore">List Your Project</button>
                      </Link> */}

                    </div>
                  </div>
                </div>
                <div>
                  <img src="\assets\stormimg.png" className="imgcards img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </>
  );
};

export default Storm;
